import { Navigate, useParams, useSearchParams } from 'react-router';
import { safeReturnTo } from '../features/auth/session';

/**
 * Stare adresy kroku „zgłoszenie udziału” (usunięty – decyzja 2026‑09‑28). Mogły trafić do maili i zakładek, więc prowadzą
 * dalej: opiekun – do zajęć, od których zaczął (`powrot`), albo do strony edycji; obsługa – do agendy rodziny.
 */
export function RegistrationRedirect() {
  const { slug = '' } = useParams();
  const back = useSearchParams()[0].get('powrot');
  return <Navigate to={back ? safeReturnTo(back) : `/edycje/${slug}`} replace />;
}

export function StaffRegistrationRedirect() {
  const { id = '', slug = '' } = useParams();
  return <Navigate to={`/obsluga/konta/${id}/edycje/${slug}/agenda`} replace />;
}
